import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import SEO from '@/components/SEO';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import MobileBar from '@/components/feature/MobileBar';
import { structureItems } from '@/mocks/structure';

export default function Estrutura() {
  const { t } = useTranslation();

  const title = t('seo.estrutura.title');
  const description = t('seo.estrutura.description');
  const keywords = t('seo.estrutura.keywords');
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://topgym.com.br';

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: title,
    description: description,
    url: `${siteUrl}/estrutura`,
    itemListElement: structureItems.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      item: {
        '@type': 'Thing',
        name: t(`structure.${item.id}.title`),
        description: t(`structure.${item.id}.description`),
        image: item.image,
      },
    })),
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: t('nav.home'),
        item: siteUrl,
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: t('page.estrutura.title'),
        item: `${siteUrl}/estrutura`,
      },
    ],
  };

  return (
    <div className="min-h-screen bg-background-50">
      <SEO title={title} description={description} keywords={keywords} path="/estrutura" schema={[schema, breadcrumbSchema]} />
      <Navbar />
      <main className="overflow-x-hidden pb-20 md:pb-0">
        <section className="bg-foreground-950 py-20 md:py-28">
          <div className="w-full px-4 md:px-6">
            <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl text-background-50">
              {t('page.estrutura.title')} <span className="text-primary-500">{t('page.estrutura.highlight')}</span>
            </h1>
            <p className="font-body text-base text-background-300 mt-4 max-w-xl">
              {t('page.estrutura.subtitle')}
            </p>
          </div>
        </section>

        <section className="py-16 md:py-24">
          <div className="w-full px-4 md:px-6">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
              {structureItems.map((item) => (
                <div key={item.id} className="group relative overflow-hidden rounded-lg bg-foreground-950">
                  <div className="aspect-[4/3] w-full">
                    <img
                      src={item.image}
                      alt={t(`structure.${item.id}.title`)}
                      loading="lazy"
                      fetchPriority="low"
                      width="800"
                      height="600"
                      decoding="async"
                      className="w-full h-full object-cover opacity-80 group-hover:opacity-100 transition-opacity duration-300"
                    />
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5 bg-gradient-to-t from-foreground-950/90 to-transparent">
                    <h3 className="font-heading text-xl md:text-2xl text-background-50">{t(`structure.${item.id}.title`)}</h3>
                    <p className="font-body text-sm text-background-400 mt-1">{t(`structure.${item.id}.description`)}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <MobileBar />
    </div>
  );
}